import {defineComponent, DataTable} from "../../src";
import App from "./App";

defineComponent(DataTable.componentName, DataTable, 'example');
defineComponent(App.componentName, App, 'example');

